export default "__VITE_ASSET__BRsqnoF6__"